<template>
  <context-list-section
    :contexts="contexts"
    :sectionTitle="folder.name"
    :folderId="folder.id"
  ></context-list-section>
</template>

<script>
import ContextListSection from './ContextListSection';
import useUserSummary from '@/store/useUserSummary';

export default {
  components: { ContextListSection },
  props: ['folder'],
  setup({ folder }) {
    const contexts = useUserSummary().filterContexts({
      limit: 8,
      sortBy: 'text',
      sortOrder: 'asc',
      filterFunc: c => c.folderId == folder.id
    });
    return { contexts };
  }
};
</script>

<style></style>
